<!--
 * @Description: 顶部统计卡片 - 商品数量、学校数量、采购订单
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
-->
<template>
  <div class="stats-cards">
    <div class="stats-item" @click="showProductDialog">
      <div class="value">
        <countTo
          :start-val="start.productCount"
          :end-val="data.productCount"
          separator=""
          :duration="countToDuration"
        ></countTo>
      </div>
      <div class="label">商品数量</div>
    </div>
    <div class="stats-item" @click="showSchoolDialog">
      <div class="value">
        <countTo
          :start-val="start.schoolCount"
          :end-val="data.schoolCount"
          separator=""
          :duration="countToDuration"
        ></countTo>
      </div>
      <div class="label">学校数量</div>
    </div>
    <div class="stats-item" @click="showOrderDialog">
      <div class="value">
        <countTo
          :start-val="start.orderCount"
          :end-val="data.orderCount"
          separator=""
          :duration="countToDuration"
        ></countTo>
      </div>
      <div class="label">采购订单</div>
    </div>

    <!-- 弹窗组件 -->
    <StatsProductDialog ref="productDialog" />
    <StatsSchoolDialog ref="schoolDialog" />
    <StatsOrderDialog ref="orderDialog" />
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import { getStatsCards } from '@/api/dashboard-tc'
import StatsProductDialog from '../dialog/StatsProductDialog.vue'
import StatsSchoolDialog from '../dialog/StatsSchoolDialog.vue'
import StatsOrderDialog from '../dialog/StatsOrderDialog.vue'

export default {
  components: {
    countTo,
    StatsProductDialog,
    StatsSchoolDialog,
    StatsOrderDialog,
  },
  data() {
    return {
      data: {
        productCount: 0,
        schoolCount: 0,
        orderCount: 0,
      },
      start: {
        productCount: 0,
        schoolCount: 0,
        orderCount: 0,
      },
      countToDuration: 3000,
      timer: null,
    }
  },
  mounted() {
    this.fetchData()
    this.timer = setInterval(() => {
      this.fetchData()
    }, process.env.VUE_APP_LTIME_TC)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async fetchData() {
      try {
        const res = await getStatsCards()
        if (res.code === 0) {
          this.start = { ...this.data }
          this.data = res.data
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    showProductDialog() {
      this.$refs.productDialog.show()
    },
    showSchoolDialog() {
      this.$refs.schoolDialog.show()
    },
    showOrderDialog() {
      this.$refs.orderDialog.show()
    },
  },
}
</script>

<style lang="scss" scoped>
.stats-cards {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 40px;
  box-sizing: border-box;

  .stats-item {
    width: 380px;
    height: 140px;
    background: url('~@/img/datav-tc/data_item_bg.png') no-repeat center;
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    .value {
      font-size: 56px;
      font-weight: bold;
      color: #66ffff;
      line-height: 1.2;
      margin-bottom: 12px;
    }

    .label {
      font-size: 24px;
      color: #ffffff;
    }
  }
}
</style>
